import type { FC } from 'react';

import { XIcon } from '@eneco/sparky/icons';

import ShareButton from './ShareButton';

const NETWORK_URL = 'https://twitter.com/intent/tweet';
const NETWORK_PARAMETERS = {
  url: 'url',
  text: 'text',
};

type Props = {
  label: string;
};

const TwitterButton: FC<Props> = ({ label }) => (
  <ShareButton label={label} networkParameters={NETWORK_PARAMETERS} networkUrl={NETWORK_URL}>
    <XIcon />
  </ShareButton>
);

export default TwitterButton;
